import { Skeleton } from './Skeleton';

export function SkeletonRequestCard() {
  return (
    <div className="request-card skeleton-card" style={{ marginBottom: 12 }}>
      <div
        style={{
          display: 'flex',
          gap: 6,
          marginBottom: 10,
        }}
      >
        <Skeleton width={70} height={24} borderRadius={7} />
        <Skeleton width={55} height={24} borderRadius={7} />
      </div>
      <Skeleton width="75%" height={14} style={{ marginBottom: 8 }} />
      <Skeleton width="100%" height={10} style={{ marginBottom: 4 }} />
      <Skeleton width="60%" height={10} />
    </div>
  );
}
